// extracted by mini-css-extract-plugin
export var Center = "index-module--Center--c0b44";
export var HideOnDesktop = "index-module--HideOnDesktop--d3154";
export var HideOnMobile = "index-module--HideOnMobile--69fd8";
export var HomeTitle = "index-module--HomeTitle--0f4ac";
export var HomeTitleDesktop = "index-module--HomeTitleDesktop--32dc0";
export var TitlePadding = "index-module--TitlePadding--a619b";